import GroupObject from "../objects/group"
import Calc from "@/common/util/calculator"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import RectObject from "@/signomatic/app/objects/rect"

export default class CableTiesFixmethod extends BaseFixmethod {
  private get param() {
    const { width } = this.state

    return {
      holeWidth: width === 30 ? Calc.mmToPx(4.9) : Calc.mmToPx(6),
      holeHeight: width === 30 ? Calc.mmToPx(2.25) : Calc.mmToPx(3.3),
      holeRadius: Calc.mmToPx(1.65),
      distanceTop: width === 60 ? Calc.mmToPx(3.275) : Calc.mmToPx(3.2),
      distanceLeft: Calc.mmToPx(3),
    }
  }

  topDrawable() {
    const { widthPx, heightPx, shape } = this.state
    const items = []
    const strokeWidth = 1 / this.drawables.scale

    const holeStroke = "#aaa"
    const holeFill = "#F5F7F6"

    if (shape === "round") {
      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: this.param.holeWidth / 2 + this.param.distanceLeft,
          top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
        }).addClass("hang")
      )

      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft,
          top: this.param.holeHeight / 2 + this.param.distanceTop - this.param.holeRadius,
        }).addClass("hang")
      )

      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: this.param.holeWidth / 2 + this.param.distanceLeft,
          top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
        }).addClass("hang")
      )

      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: widthPx - this.param.holeWidth / 2 - this.param.distanceLeft,
          top: heightPx - this.param.holeHeight / 2 - this.param.distanceTop + this.param.holeRadius,
        }).addClass("hang")
      )
    } else {
      // Stop shape for thermal transfer label 30x20
      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: 0,
          top: heightPx / 2 - Calc.mmToPx(3.35),
        }).addClass("hang")
      )

      items.push(
        new RectObject({
          fill: holeFill,
          stroke: holeStroke,
          strokeWidth: strokeWidth,
          rx: this.param.holeRadius,
          width: this.param.holeWidth,
          height: this.param.holeHeight,
          left: 0,
          top: -heightPx / 2 + Calc.mmToPx(3.35),
        }).addClass("hang")
      )
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }
}
